import SpecialOrderService from "@/core/services/specialOrderService";

export default ({ }: any, inject: any) => {
  inject(
    "specialOrder",
    new SpecialOrderService(),
  );
};
